require("../../node_modules/slick-carousel/slick/slick.js");

module.exports = {
  init: () => {
    $(".slideshow").slick({
      prevArrow: $(".slideshow-controls-prev"),
      nextArrow: $(".slideshow-controls-next"),
      autoplay: true,
      autoplaySpeed: 8000,
      rows: 0,
      slide: ".hero",
    });

    $(".slick-slide").show();

    $(".imageslider").each((i, slider) => {
      const $slider = $(slider);
      $slider.slick({
        appendDots: $slider.closest(".imageslider-wrapper").find(".imageslider-dots"),
        dots: true,
        prevArrow: $slider.find(".imageslider-control--prev"),
        nextArrow: $slider.find(".imageslider-control--next"),
        autoplay: false,
        rows: 0,
        slide: ".imageslider-slide",
      });
    });

    $(".textslider-wrapper").each((i, sliderWrapper) => {
      const $sliderWrapper = $(sliderWrapper);
      const $sliderImages = $sliderWrapper.find(".textslider--images");
      const $sliderTexts = $sliderWrapper.find(".textslider--texts");
      const $sliderTextsSlide = $sliderWrapper.find(".textslider--texts > .rte");
      const $hasTextSlideshow = $sliderTextsSlide.length > 1 ? true : false;

      if ($hasTextSlideshow) {
        $sliderImages.slick({
          dots: false,
          prevArrow: $sliderWrapper.find(".textslider-control--prev"),
          nextArrow: $sliderWrapper.find(".textslider-control--next"),
          autoplay: false,
          rows: 0,
          slide: ".textslider-slide",
          asNavFor: $sliderTexts,
        });
        $sliderTexts.slick({
          dots: false,
          arrows: false,
          draggable: false,
          autoplay: false,
          rows: 0,
          slide: ".rte",
          asNavFor: $sliderImages,
          fade: true,
        });
      } else {
        $sliderImages.slick({
          dots: false,
          prevArrow: $sliderWrapper.find(".textslider-control--prev"),
          nextArrow: $sliderWrapper.find(".textslider-control--next"),
          autoplay: false,
          rows: 0,
          slide: ".textslider-slide",
        });
      }
    });

    $(".damages-slideshow").each((i, slider) => {
      const $slider = $(slider);
      $slider.slick({
        dots: false,
        autoplay: false,
        rows: 0,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 3,
        slide: ".damages-slideshow-item",
        prevArrow: $(".damages-slideshow-nav--prev"),
        nextArrow: $(".damages-slideshow-nav--next"),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    });
  },
};
